<template>
  <div class="event-list" v-if="eventList">
    <div class="event-list__nav">
      <nav-popup v-if="isMobile" :itemList="navList" :active="active" @select="onSelect" />
      <nav-list v-else :itemList="navList" :active="active" @select="onSelect" />
    </div>

    <gala-list :galaList="eventList.gala" v-show="active === 0">
      <template v-slot:default="props">
        <event-item class="event-list__event" :item="props.item" />
      </template>
    </gala-list>
    <russia-list :russiaList="eventList.russia" v-show="active === 1">
      <template v-slot:default="props">
        <event-item class="event-list__event" :item="props.item" />
      </template>
    </russia-list>

    <div class="event-list__footer">
      <double-btn tag="a" iconName="download" iconNameHover="download-hover" href="09.05.2020.pdf">
        Скачать полную программу
      </double-btn>
    </div>
  </div>
</template>

<script>
import NavList from '../shared/NavList'
import NavPopup from '../shared/NavPopup'
import GalaList from './GalaList'
import RussiaList from './RussiaList'
import DoubleBtn from '../shared/DoubleBtn'
import EventItem from './EventItem'

export default {
  components: {
    NavList,
    NavPopup,
    GalaList,
    RussiaList,
    DoubleBtn,
    EventItem
  },
  data () {
    return {
      navList: ['Праздничная программа', 'Всероссийские акции'],
      active: 0,
      eventList: null
    }
  },
  computed: {
    isMobile () {
      return this.$mq.resize && this.$mq.below(this.$mv.sm)
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.$http.static.get('/data/event.json')
        .then((response) => {
          this.eventList = response.data
        }, (error) => {
          console.error(error)
        }).catch(() => null)
    },
    onSelect (index) {
      this.active = index
    }
  }
}
</script>

<style lang="scss" scoped>
.event-list {
  &__nav {
    margin-bottom: 60px;
  }

  &__footer {
    margin-top: 10px;
    text-align: center;
  }
}
</style>
